import React from 'react'

import { PlayCircleFillSvg } from '@svg/react'

export type ActionType = 'showcase' | 'remote'

interface VideoPlaybackActionsProps {
  className?: string
  onPlay: (actionType: ActionType) => void
  disable?: boolean
  disableShowcasePlayAction?: boolean
  disableRemotePlayAction?: boolean
}

function VideoPlaybackActions({
  className,
  onPlay,
  disable,
  disableShowcasePlayAction,
  disableRemotePlayAction,
}: VideoPlaybackActionsProps) {
  const handlePlay = React.useCallback(
    (actionType: ActionType) => (event: React.MouseEvent) => {
      event.stopPropagation()
      onPlay(actionType)
    },
    [onPlay]
  )

  return (
    <div className={`flex flex-row gap-5 ${className}`}>
      <button
        type="button"
        className="z-1 flex items-center gap-1 rounded-full bg-black bg-opacity-50 p-px pr-4 text-white disabled:cursor-not-allowed disabled:bg-opacity-20 disabled:text-white/75"
        disabled={disable || disableRemotePlayAction}
        onClick={handlePlay('remote')}
      >
        <PlayCircleFillSvg
          size="s"
          className={`h-[50px] w-[50px] ${disable || disableRemotePlayAction ? 'fill-white/75' : 'fill-white'}`}
        />
        <span className="mt-px text-[17px] font-semibold uppercase leading-[17px] tracking-[1px]">
          Play on this device
        </span>
      </button>
      <button
        type="button"
        className="z-1 flex items-center gap-1 rounded-full bg-black bg-opacity-50 p-px pr-4 text-white disabled:cursor-not-allowed disabled:bg-opacity-20 disabled:text-white/75"
        disabled={disable || disableShowcasePlayAction}
        onClick={handlePlay('showcase')}
      >
        <PlayCircleFillSvg
          size="s"
          className={`h-[50px] w-[50px] ${disable || disableShowcasePlayAction ? 'fill-white/75' : 'fill-white'}`}
        />
        <span className="mt-px text-[17px] font-semibold uppercase leading-[17px] tracking-[1px]">
          Play on connected display
        </span>
      </button>
    </div>
  )
}

export default VideoPlaybackActions
